export default "/images/c20be25be7347257a909a45dd1f92674.png";